module.exports = __webpack_public_path__ + "img/Inleiding.6bf2f302.jpg";